import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const listByItem = (merchantId, menuItemCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/menuItems/${menuItemCode}/member-prices`,
		payload
	);
};

const upsertByItem = (merchantId, menuItemCode, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/menuItems/${menuItemCode}/member-prices`,
		payload
	);
};

const removeByGrade = (merchantId, menuItemCode, memberGradeId, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/menuItems/${menuItemCode}/member-prices/${memberGradeId}`,
		payload
	);
};

const listAll = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/member-prices`, payload);
};

export default {
	listByItem,
	upsertByItem,
	removeByGrade,
	listAll,
};
